import { useEffect, useState } from 'react';

import { DynamicForm } from '@admin/molecules/DynamicForm';
import { type FormFields } from '@admin/types';

export interface Props<Entity, FormEntity> {
    id: string;
    action: string;
    handleSubmit: (data: FormEntity) => Promise<void>;
    bindDoSubmit: (callback: () => void) => void;
    formFields: FormFields;
    entity?: Entity;
    onDataInvalid?: () => void;
    setEmptyFieldsToNull?: boolean;
}

export function Form<Entity, FormEntity>({
    id,
    action,
    handleSubmit,
    bindDoSubmit,
    entity,
    formFields,
    onDataInvalid,
    setEmptyFieldsToNull,
}: Props<Entity, FormEntity>) {
    const [formData, setFormData] = useState<FormEntity>(entity as unknown as FormEntity);

    useEffect(() => {
        if (entity) setFormData(entity as unknown as FormEntity);
    }, [entity]);

    const onSubmit = (data: FormEntity) => {
        if (data) setFormData(data);
        return handleSubmit(data);
    };

    return (
        <DynamicForm
            id={id}
            items={formFields}
            data={formData}
            onSubmit={onSubmit}
            onDataInvalid={onDataInvalid}
            action={action}
            bindDoSubmit={bindDoSubmit}
            setEmptyFieldsToNull={setEmptyFieldsToNull}
        />
    );
}
